import { defineStore } from "pinia";
import { ref } from "vue";
import { SearchResult } from "../models/link";
import api from "../plugins/api";

export const useSearchStore = defineStore('search', () => {
  let searchResults = ref(<SearchResult[]>[]);
  let showSearch = ref(false);

  async function search(term: string, types?: string[]) {
    if (!term) {
      searchResults.value = [];
      return;
    }

    try {
      const { data } = await api.post(`/search`, { searchTerm: term, types });
      
      searchResults.value = data.map((item: any): SearchResult => {
        if (!item.id || !item.name || !item.type) {
          console.warn("Skipping item due to missing properties:", item);
        }

        return {
          id: String(item.id),
          name: String(item.name),
          image_url: String(item.imageUrl || item.image_url || ''),
          type: String(item.type),
          channel_id: item.channelId,
          channel_name: item.channelName,
          channel_image_url: item.channelImageUrl,
        };
      });
    } catch (error: any) {
      console.error("Search failed:", error);
      throw error;
    }
  }
  
  return {
    showSearch,
    searchResults,
    search 
  }
});